<!-- tinymc富文本 -->
<template>
    <div>
      <editor
        v-model="myValue"
        :init="init"
        :disabled="disabled"
        @onClick="onClick"
      >
      </editor>
    </div>
  </template>
  
  <script>
  import tinymce from "tinymce/tinymce";
  import Editor from "@tinymce/tinymce-vue";
  import "tinymce/skins/ui/oxide/skin.css";
  import "@/assets/tinymce/langs/zh_CN.js"; // 本地汉化
  import "tinymce/themes/silver/theme";
  //下面这些引入路径中带plugins的都是引入安装的依赖包里面的插件;
  //如果你想使用和展示该插件功能，就要先引入
  import "tinymce/plugins/image";
  import 'tinymce/plugins/media'
  import 'tinymce/plugins/table'
  import "tinymce/plugins/lists";
  import "tinymce/plugins/contextmenu";
  import "tinymce/plugins/wordcount";
  import "tinymce/plugins/colorpicker";
  import "tinymce/plugins/textcolor";
  import "tinymce/plugins/fullscreen";
  import "tinymce/plugins/hr";
  import "tinymce/plugins/preview";
  import "tinymce/plugins/print";
  import "tinymce/icons/default"; // 图标 -解决测试环境找不icon问题
  export default {
    name: "tinymce",
    components: {
      Editor,
    },
    props: {
      //传入一个value，使组件支持v-model绑定
      value: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      plugins: {
        type: [String, Array],
        default:"lists image media table  wordcount preview fullscreen print hr importword",
      },
      toolbar: {
        type: [String, Array],
        default:
            //"undo redo | " +
            "fontselect fontsizeselect |"+
            "bold italic underline | "+
            //"forecolor backcolor | "+
            "alignleft aligncenter alignright alignjustify | "+
            "removeformat hr |"  +
            //"bullist numlist outdent indent | "+
            //"importword lists image media table | "+
            "preview fullscreen print | ",
      },
    },
    data() {
      return {
        //初始化配置
        init: {
          language_url: "@assets/tinymce/langs/zh_CN.js", // 这里需要单独处理
          language: "zh_CN",
          height: 400,
          width:"70%",
          plugins: this.plugins,
          toolbar: this.toolbar,
          branding: true,
          menubar: true,
          images_upload_handler: (blobInfo, success, failure) => {
            const img = "data:image/jpeg;base64," + blobInfo.base64();
            success(img);
          },
          //设置默认展示的字体和字号
          setup: function(editor) {
             editor.on('init', function(ed) {
                  this.getBody().style.fontSize = '14pt';
                  this.getBody().style.fontFamily = '微软雅黑';
              });                       
          },
          

          resize: true,
        },
        myValue: this.value,
      };
    },
    mounted() {
      tinymce.init({});
    },
    methods: {
      onClick(e) {
        this.$emit("onClick", e, tinymce);
      },
      clear() {
        this.myValue = "";
      },
    },
    watch: {
      value(newValue) {
        this.myValue = newValue;
      },
      myValue(newValue) {
        this.$emit("input", newValue);
      },
    },
  };
  </script>
  <style scoped></style>
  
  